export const defaultMapOptions = {
  scrollwheel: true,
  mapTypeControl: false,
  fullscreenControl: false,
  streetViewControl: false,
  drawingControl: true,
};

export const DEFAULT_CENTER = { lat: 39.8097343, lng: -98.5556199 };

export const ZOOM = {
  default: 4,
  country: 5,
  state: 8,
  market: 9,
};

export const mapContainerStyle = (height) => ({
  width: '100%',
  height,
});

export const FEATURE_SETTINGS = {
  Proficient: '#5ED14F',
  Develop: '#FFE400',
  Insufficient: '#FF230A',
  default: '#999',
  selectedFillOpacity: 0.9,
  selectedStrokeWeight: 2,
  zipCodeStrokeColor: 'white',
  zipCodeStrokeOpacity: 1.0,
  zipCodeStrokeWeight: 0.6,
  zipCodeFillOpacity: 0.5,
  countryMarkersStrokeColor: '#19867F',
  countryMarkerScale: 12,
  countryMarkerFillOpacity: 1,
  countryMarkerStrokeWeight: 0.5,
  countryMarkerLabelColor: 'black',
  countryMarkerFontSize: '12px',
  lotHover: {
    strokeColor: 'white',
    strokeOpacity: 1,
    strokeWeight: 1,
    fillOpacity: 1,
  },
  lot: {
    strokeColor: 'white',
    strokeOpacity: 1,
    strokeWeight: 1,
    fillOpacity: 0.6,
  },
  franchise: {
    strokeColor: '#000000',
    strokeOpacity: 1,
    strokeWeight: 1.5,
    fillColor: 'transparent',
    fillOpacity: 0,
  },
};

export const MARKER_ICON = {
  path: 0,
  scale: FEATURE_SETTINGS.countryMarkerScale,
  fillColor: FEATURE_SETTINGS.countryMarkersStrokeColor,
  fillOpacity: FEATURE_SETTINGS.countryMarkerFillOpacity,
  strokeWeight: FEATURE_SETTINGS.countryMarkerStrokeWeight,
  strokeColor: FEATURE_SETTINGS.countryMarkersStrokeColor,
};

export const MAP_VIEW = {
  country: 'countryView',
  state: 'stateView',
  lot: 'lotView',
};

export const LAYERS = {
  lot: 'lot',
  franchise: 'franchise',
};

export const STATUS_CLASS = {
  available: 'bg-[#6780BD]',
  pending: 'bg-[#F5C08C]',
  sold: 'bg-[#B3B6BB]',
};
